import { Tooltip } from '@yuno/design-system-web'
import { useTranslation } from 'react-i18next'

interface PermissionsTooltipProps {
  allowed: boolean
  children: React.ReactNode
}

export const PermissionsTooltip = ({
  allowed,
  children,
}: PermissionsTooltipProps) => {
  const { t } = useTranslation()

  return (
    <Tooltip
      disableHoverListener={allowed}
      disableInteractive
      title={t('noAccess')}
      color="default"
      arrow
    >
      <span>{children}</span>
    </Tooltip>
  )
}
